import {alias, createModelSchema, list} from "serializr";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";

export class CardCluster extends BaseObject {

    constructor() {
        super();

        this._key = null;
        this._name = null;
        this._rarity = 0;
        this._cards = [];
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get rarity() {
        return this._rarity;
    }

    set rarity(value) {
        this._rarity = value;
    }

    get cards() {
        return this._cards;
    }

    set cards(value) {
        this._cards = value;
    }

    valid() {

        if (!this.name || this.name.length <= 0) {
            return false;
        }

        if (!this.key || this.key.length <= 0) {
            return false;
        }

        if (!Number.isInteger(this.rarity) || this.rarity <= 0 || this.rarity > 6) {
            return false;
        }

        if (!this.cards || this.cards.length <= 0) {
            return false;
        }

        if (this.cards && this.cards.some(v => !v || !RedactorUtils.getCard(v))) {
            return false;
        }

        return true;
    }

    empty() {
        return this.cards.length <= 0;
    }

    copy() {
        let value = super.copy();
        value._enabled = false;
        return value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new CardCluster());
        } else if (target instanceof CardCluster) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(CardCluster, {
    _key: alias("key", Schema.primitive()),
    _name: alias("name", Schema.primitive()),
    _rarity: alias("rarity", Schema.primitive()),
    _cards: alias("cards", list(Schema.primitive()))
});